import {useNavigate} from "react-router";
import {Button, Container, Typography} from "@mui/material";
import ReportOutlinedIcon from '@mui/icons-material/ReportOutlined';

export function Route404() {
    const navigate = useNavigate();

    return (
        <Container
            maxWidth="md"
            sx={{
                textAlign: 'center',
                py: 10,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <ReportOutlinedIcon color="error" sx={{ fontSize: 80, mb: 2 }} />
            <Typography variant="h3" gutterBottom>
                404 - Page Not Found
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
                Sorry, the page you are looking for doesn’t exist or has been moved.
            </Typography>
            <Button
                variant="contained"
                color="primary"
                onClick={() => navigate('/')}
            >
                Go to Homepage
            </Button>
        </Container>
    );
}